import React from "react";
import { Container, Row, Col } from "react-bootstrap";

// Note: Ensure your main application imports './study_abroad_stats_final_separate.css'
import S1img from "../images/s1.png";
import S2img from "../images/s2.png";
import S3img from "../images/s3.png";

// Component for the Icon Graphic
const StatIconGraphic = ({ colorClass, iconType }) => {
  let iconImgSrc = null; // Declare the variable and give it a default value

  // Select the correct image source based on the iconType prop
  switch (iconType) {
    case "map":
      iconImgSrc = S1img;
      break;
    case "university":
      iconImgSrc = S2img;
      break;
    case "student":
      iconImgSrc = S3img;
      break;
    default:
      // Keep iconImgSrc as null if no match is found
      break;
  }

  // This return statement renders the icon
  return (
    <div className={`stat-icon-wrapper ${colorClass}`}>
      {/* Conditionally render the image only if a source was found */}
      {iconImgSrc && <img src={iconImgSrc} alt={`${iconType} icon`} />}
    </div>
  );
};

// Main component for the entire stats section
const StudyAbroadStats = () => {
  return (
    <div style={{ padding: "0px 13px" }}>
      <div className="rectangle loan-tc d-block d-md-none">
        <ul className="loan-list loan-tc d-block d-md-none">
          <li>Loan Amount Ranging From Rs. 10 Lacs to Rs. 1.5Cr.*</li>
          <li>Attractive student loan interest rates</li>
          <li>100% finance for course fee and other expenses</li>
          <li>Sanction within 3 days*</li>
        </ul>
        <span className="loan-tc d-none d-md-block"></span>
      </div>
      <div className="study-abroad-stats-section">
        <Container>
          <div className="section-2">
            Transforming Futures Through
            <p>Education Loan</p>
            <p class="transform-description">We are committed to easing your journey. So far, we've helped fulfil the academics aspirations of</p>
          </div>
          <Row className="justify-content-center g-4">
            {/* Stat Card 3: Students (Teal) */}
            <Col
              xs={12}
              md={6}
              lg={4}
              className="d-flex justify-content-center"
            >
              <div className="stat-card">
                <div className="stat-bar stat-bar-teal">
                  <div className="stat-tab stat-tab-teal"></div>
                </div>
                <div className="stat-content">
                  <StatIconGraphic colorClass="bg-teal" iconType="student" />
                  <div className="stat-text">
                    <div className="stat-number text-teal">64,000+</div>
                    <div className="stat-label text-teal-label">Network of Students</div>
                    <div className="stat-description">
                      Empowered to study abroad
                    </div>
                  </div>
                </div>
              </div>
            </Col>

            {/* Stat Card 2: Universities (Orange) */}
            <Col
              xs={12}
              md={6}
              lg={4}
              className="d-flex justify-content-center"
            >
              <div className="stat-card">
                <div className="stat-bar stat-bar-orange">
                  <div className="stat-tab stat-tab-orange"></div>
                </div>
                <div className="stat-content">
                  <StatIconGraphic
                    colorClass="bg-orange"
                    iconType="university"
                  />
                  <div className="stat-text">
                    <div className="stat-number text-orange">1,750+</div>
                    <div className="stat-label text-orange-label">
                      In Institutes
                    </div>
                    <div className="stat-description">
                      Education loans available
                    </div>
                  </div>
                </div>
              </div>
            </Col>

            {/* Stat Card 1: Countries (Yellow) */}
            <Col
              xs={12}
              md={6}
              lg={4}
              className="d-flex justify-content-center"
            >
              <div className="stat-card">
                <div className="stat-bar stat-bar-yellow">
                  <div className="stat-tab stat-tab-yellow"></div>
                </div>
                <div className="stat-content">
                  <StatIconGraphic colorClass="bg-yellow" iconType="map" />
                  <div className="stat-text">
                    <div className="stat-number text-yellow">51+</div>
                    <div className="stat-label text-yellow-label">
                      Across Countries
                    </div>
                    <div className="stat-description">
                      Education loans available
                    </div>
                  </div>
                </div>
              </div>
            </Col>

            
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default StudyAbroadStats;
